import { CompanyParams } from 'app/models/companies-params'

export const getCompanies = (state: {
  companies: { companies: CompanyParams[] }
}) => {
  return state.companies.companies
}

export const getCompanyLoader = (state: {
  companies: { isLoading: boolean }
}) => {
  return state.companies.isLoading
}
